/* ELLESANTI · tema V3 · componenti condivisi (prototipo V8): slider con frecce, barra di avanzamento, trascinamento e scroll-snap.
   Si inizializza da solo e ogni volta che l'editor di Shopify ricarica una sezione (EllesantiV3.hooks). CTRL+G · 29/09/2026. */
(function () {
  'use strict';
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function initSl(scope) {
    $$('[data-e-sl]', scope).forEach(function (sl) {
      if (sl._e) return;
      sl._e = true;
      var track = $('.e-sl__track', sl), bar = $('.e-sl__bar i', sl), sec = sl.closest('section') || sl.parentNode;
      var prev = sec && $('[data-e-sl-prev]', sec), next = sec && $('[data-e-sl-next]', sec);
      if (!track) return;
      var step = function () {
        var c = track.children[0];
        if (!c) return 1;
        return c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      };
      var upd = function () {
        var max = track.scrollWidth - track.clientWidth, x = track.scrollLeft, w = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        if (bar) {
          bar.style.width = (Math.min(1, w) * 100).toFixed(2) + '%';
          bar.style.transform = 'translateX(' + (max > 0 && w < 1 ? (x / max) * ((1 - w) / w) * 100 : 0).toFixed(2) + '%)';
        }
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= max - 2;
        sl.classList.toggle('is-fit', max <= 2);
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: RM ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: RM ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
      var drag = false, sx = 0, s0 = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = true; moved = false; sx = e.clientX; s0 = track.scrollLeft;
        track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto'; track.classList.add('is-grab');
      });
      /* trascinamento col mouse più sensibile (06/10): il movimento vale 1,6 volte e al rilascio va alla scheda
         successiva nella direzione del gesto, così anche un trascinamento breve fa avanzare */
      var K = 1.6, ldx = 0;
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - sx;
        ldx = dx;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = s0 - dx * K;
      });
      window.addEventListener('pointerup', function () {
        if (!drag) return;
        drag = false;
        track.classList.remove('is-grab');
        var s = step(), r = track.scrollLeft / s, i = Math.abs(ldx) > 24 ? (ldx < 0 ? Math.ceil(r - 0.05) : Math.floor(r + 0.05)) : Math.round(r);
        ldx = 0;
        track.style.scrollBehavior = ''; track.style.scrollSnapType = '';
        track.scrollTo({ left: i * s, behavior: RM ? 'auto' : 'smooth' });
      });
      /* la barra sotto lo slider si trascina e si clicca (mouse e dito) */
      var barEl = bar && bar.parentNode, bdrag = false;
      if (barEl) {
        var barGo = function (cx, smooth) {
          var r = barEl.getBoundingClientRect(), tw = bar.getBoundingClientRect().width, max = track.scrollWidth - track.clientWidth;
          if (max <= 0 || r.width <= tw) return;
          var f = Math.max(0, Math.min(1, (cx - r.left - tw / 2) / (r.width - tw)));
          track.style.scrollBehavior = 'auto';
          if (smooth) { track.style.scrollBehavior = ''; track.scrollTo({ left: f * max, behavior: RM ? 'auto' : 'smooth' }); }
          else track.scrollLeft = f * max;
        };
        barEl.addEventListener('pointerdown', function (e) {
          if (e.button !== 0) return;
          bdrag = true; e.preventDefault();
          try { barEl.setPointerCapture(e.pointerId); } catch (err) {}
          track.style.scrollSnapType = 'none'; barEl.classList.add('is-grab');
          barGo(e.clientX, false);
        });
        barEl.addEventListener('pointermove', function (e) { if (bdrag) barGo(e.clientX, false); });
        var barEnd = function () {
          if (!bdrag) return;
          bdrag = false; barEl.classList.remove('is-grab');
          var s = step(), i = Math.round(track.scrollLeft / s);
          track.style.scrollBehavior = ''; track.style.scrollSnapType = '';
          track.scrollTo({ left: i * s, behavior: RM ? 'auto' : 'smooth' });
        };
        barEl.addEventListener('pointerup', barEnd);
        barEl.addEventListener('pointercancel', barEnd);
      }
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      sl._go = function (i) { track.style.scrollBehavior = 'auto'; track.scrollLeft = i * step(); upd(); };
      sl._upd = upd;
    });
  }

  function init(scope) { initSl(scope || document); }
  window.EllesantiV3 = window.EllesantiV3 || {};
  window.EllesantiV3.hooks = window.EllesantiV3.hooks || [];
  window.EllesantiV3.hooks.push(init);
  window.EllesantiV3.slider = initSl;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
